module.exports = __webpack_public_path__ + "static/media/take-away.ea8a9e2d.svg";